// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VN8Q","col":"styles_col__3dSej"};